export class Dropdowndaten {
  alleVorschlaege: any[];
  minlaenge: number;
  maxlaenge: number;
  fehler: Record<string, any> | undefined;
  required: boolean;
  placeholder: string;
  fehlermeldung: string;

  public constructor(
    alleVorschlaege: any[],
    minlaenge: number,
    maxlaenge: number,
    fehler: Record<string, any> | undefined,
    required: boolean,
    placeholder: string,
    fehlermeldung: string,
  ) {
    this.alleVorschlaege = alleVorschlaege;
    this.minlaenge = minlaenge;
    this.maxlaenge = maxlaenge;
    this.fehler = fehler;
    this.required = required;
    this.placeholder = placeholder;
    this.fehlermeldung = fehlermeldung;
  }
}
